// geometric-mosaic — m02 "Yodgorlik" Islamic memorial preview card.
//
// Reverent Bukhara-tile memorial. Warm sand paper with a brass-tone accent.
// An eight-point Islamic geometric star sits in the centre as the focal
// ornament; the deceased's name renders in Marcellus serif with an "XOTIRA"
// eyebrow and city line beneath.
import { Photo, type LayoutCtx } from "./_shared";

export function GeometricMosaicLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(180deg, ${bg} 0%, ${accent}1A 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}33`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          XOTIRA
        </div>

        {/* Islamic geometric medallion */}
        <div style={{ width: "60%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <Photo
            src={photo}
            style={{ position: "absolute", inset: "16%", borderRadius: "4px" }}
            fallback={
              <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", display: "block" }}>
                <circle cx="50" cy="50" r="46" fill="none" stroke={accent} strokeWidth="0.5" opacity="0.55" />
                {/* Eight-point star (two rotated squares) */}
                <g fill="none" stroke={accent} strokeWidth="0.7" opacity="0.85">
                  <polygon points="50,8 92,50 50,92 8,50" />
                  <polygon points="50,8 92,50 50,92 8,50" transform="rotate(45 50 50)" />
                  <circle cx="50" cy="50" r="22" />
                </g>
                {/* Small dots in eight petals */}
                {[0, 45, 90, 135, 180, 225, 270, 315].map((d) => (
                  <g key={d} transform={`rotate(${d} 50 50)`}>
                    <circle cx="50" cy="14" r="1.4" fill={accent} opacity="0.8" />
                  </g>
                ))}
                {/* Central candle */}
                <g transform="translate(50 50)">
                  <ellipse cx="0" cy="2" rx="2.6" ry="0.8" fill={accent} opacity="0.5" />
                  <rect x="-1.2" y="-6" width="2.4" height="8" fill={accent} opacity="0.6" />
                  <ellipse cx="0" cy="-9" rx="1.4" ry="3.4" fill={accent} opacity="0.85" />
                </g>
              </svg>
            }
          />
        </div>

        <div style={{ fontFamily: font, fontSize: 28, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          XOTIRA · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
